import { useSidebarPermission } from "../Context/SidebarPermissionContext";

// Helper function to determine if permission is granted
export const HasPermission = (permissionName) => {
    const { permissions } = useSidebarPermission();
    const permission = Array.isArray(permissions) && permissions.length > 0 && permissions.find(p => p.permission === permissionName);
    //permission.allow should be true and permission.enabled should also be true
    if (permission && permission.allow && permission.enabled) {
        return true;
    }
    return false;
}

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};


export const formatDate = (inputDate) => {
    if (inputDate == null || inputDate == "") {
        return ""
    }
    const date = new Date(inputDate);

    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();

    const formattedDate = `${month}/${day}/${year}`;

    return formattedDate;
}
export const formatDateTime = (inputDate) => {
    if (inputDate == null || inputDate === "") {
        return "";
    }
    const date = new Date(inputDate);

    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    let currentTime = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
    const formattedDate = `${month}/${day}/${year}`+' '+currentTime;
    return formattedDate;
};

// Helper function to check if 60 minutes have passed since timestamp
export const has60MinutesPassed = (timestamp) => {
    if (!timestamp) return false;
    const now = new Date();
    const loginAttemptTime = new Date(timestamp);
    const diffInMs = now - loginAttemptTime;
    const sixtyMinutesInMs = 60 * 60 * 1000;
    return diffInMs >= sixtyMinutesInMs; // Return true if 60+ minutes have passed
};

// Common function to determine if unlock functionality should be available
export const shouldShowUnlockButton = (loginAttemptCount, lastLoginAttempt, adminFlag, persona) => {
    // Base requirement: Login attempt count >= 6
    const hasMinimumLoginAttempts = loginAttemptCount && parseInt(loginAttemptCount) >= 6;
    
    // Time requirement: 60 minutes must have passed since last login attempt
    const hasTimeExpired = lastLoginAttempt && has60MinutesPassed(lastLoginAttempt);
    
    // User type requirement: Must be admin OR support user
    const isAdministrator = adminFlag === '1' || adminFlag === 1 || adminFlag === true;
    const isSupportUser = persona === 'support' || persona === 'Support';
    const isAuthorizedUser = isAdministrator || isSupportUser;

    // All conditions must be true: base count + time expired + authorized user type
    return hasMinimumLoginAttempts && hasTimeExpired && isAuthorizedUser;
};